module.exports = __webpack_public_path__ + "img/3_112.c62ea312.png";